/**
 * GENERATED by tools/derive-crib-table.ts — do not edit by hand.
 * Mode: model opponent (pass 2); 8000 samples per cell.
 * Index [rankA-1][rankB-1], ranks 1..13 (A..K). Symmetric.
 *
 * DEALER_THROW: expected value of the dealer's own crib for throwing these two.
 * PONE_THROW:   expected value of the dealer's crib when the pone throws these two.
 */
export const DEALER_THROW: readonly (readonly number[])[] = [
  [5.15, 4.10, 4.34, 5.25, 5.36, 3.81, 3.72, 3.78, 3.29, 3.33, 3.50, 3.26, 3.31],
  [4.10, 5.63, 6.85, 4.42, 5.42, 3.88, 3.90, 3.65, 3.62, 3.44, 3.63, 3.41, 3.47],
  [4.34, 6.85, 5.82, 4.70, 5.91, 3.70, 3.78, 3.88, 3.66, 3.57, 3.74, 3.48, 3.54],
  [5.25, 4.42, 4.70, 5.61, 6.37, 3.81, 3.70, 3.87, 3.62, 3.55, 3.66, 3.50, 3.47],
  [5.36, 5.42, 5.91, 6.37, 8.66, 6.44, 6.00, 5.46, 5.43, 6.45, 6.75, 6.48, 6.51],
  [3.81, 3.88, 3.70, 3.81, 6.44, 5.79, 4.96, 4.76, 5.10, 3.04, 3.23, 3.04, 3.10],
  [3.72, 3.90, 3.78, 3.70, 6.00, 4.96, 5.99, 6.65, 4.05, 3.16, 3.35, 3.16, 3.20],
  [3.78, 3.65, 3.88, 3.87, 5.46, 4.76, 6.65, 5.50, 4.76, 3.93, 3.32, 3.15, 3.21],
  [3.29, 3.62, 3.66, 3.62, 5.43, 5.10, 4.05, 4.76, 5.06, 4.15, 3.79, 2.93, 3.00],
  [3.33, 3.44, 3.57, 3.55, 6.45, 3.04, 3.16, 3.93, 4.15, 4.57, 4.32, 3.24, 2.73],
  [3.50, 3.63, 3.74, 3.66, 6.75, 3.23, 3.35, 3.32, 3.79, 4.32, 5.09, 4.57, 3.78],
  [3.26, 3.41, 3.48, 3.50, 6.48, 3.04, 3.16, 3.15, 2.93, 3.24, 4.57, 4.51, 3.32],
  [3.31, 3.47, 3.54, 3.47, 6.51, 3.10, 3.20, 3.21, 3.00, 2.73, 3.78, 3.32, 4.52],
];
export const PONE_THROW: readonly (readonly number[])[] = [
  [6.07, 5.08, 5.18, 5.72, 6.10, 4.93, 4.76, 4.91, 4.75, 4.60, 4.77, 4.38, 4.27],
  [5.08, 6.54, 7.34, 5.55, 6.30, 5.21, 5.11, 5.10, 4.93, 4.82, 5.00, 4.72, 4.53],
  [5.18, 7.34, 6.92, 6.09, 6.93, 4.99, 5.12, 5.17, 4.95, 4.77, 5.00, 4.69, 4.50],
  [5.72, 5.55, 6.09, 6.74, 7.51, 5.53, 4.89, 5.09, 4.92, 4.68, 4.87, 4.53, 4.33],
  [6.10, 6.30, 6.93, 7.51, 9.45, 7.67, 7.00, 6.32, 6.24, 7.50, 7.61, 7.36, 7.20],
  [4.93, 5.21, 4.99, 5.53, 7.67, 7.10, 6.27, 5.87, 6.29, 4.42, 4.62, 4.23, 4.11],
  [4.76, 5.11, 5.12, 4.89, 7.00, 6.27, 7.00, 7.70, 5.16, 4.43, 4.61, 4.22, 4.14],
  [4.91, 5.10, 5.17, 5.09, 6.32, 5.87, 7.70, 6.57, 5.78, 4.94, 4.60, 4.26, 4.12],
  [4.75, 4.93, 4.95, 4.92, 6.24, 6.29, 5.16, 5.78, 6.41, 5.49, 5.08, 4.10, 4.02],
  [4.60, 4.82, 4.77, 4.68, 7.50, 4.42, 4.43, 4.94, 5.49, 6.23, 5.59, 4.74, 3.90],
  [4.77, 5.00, 5.00, 4.87, 7.61, 4.62, 4.61, 4.60, 5.08, 5.59, 6.49, 5.33, 4.71],
  [4.38, 4.72, 4.69, 4.53, 7.36, 4.23, 4.22, 4.26, 4.10, 4.74, 5.33, 5.88, 4.49],
  [4.27, 4.53, 4.50, 4.33, 7.20, 4.11, 4.14, 4.12, 4.02, 3.90, 4.71, 4.49, 5.52],
];
export function cribValue(throwCards: readonly number[], isDealer: boolean): number {
  const a = (throwCards[0]! % 13), b = (throwCards[1]! % 13);
  return (isDealer ? DEALER_THROW : PONE_THROW)[a]![b]!;
}
